import AsyncStorage from '@react-native-async-storage/async-storage';
import { unionBy } from 'lodash';
import { PNActionTypes, PNAction, IPNState } from '../../interfaces/pushNotification';

const Reducer = (state: IPNState, action: PNAction): IPNState => {

    switch (action.type) {
        case PNActionTypes.set:
            return {
                ...state,
                notifications: action.payload
            };
        case PNActionTypes.add:
            const notifications = unionBy(state.notifications, [action.payload], 'request.identifier')
            AsyncStorage.setItem('RN4notifications', JSON.stringify(notifications))
            return {
                ...state,
                notifications
            }
        case PNActionTypes.remove:
            const filtered = state.notifications.filter((item) => item?.request?.identifier !== action?.payload)
            AsyncStorage.setItem('RN4notifications', JSON.stringify(filtered))
            return {
                ...state,
                notifications: filtered
            }
        case PNActionTypes.clear:
            AsyncStorage.setItem('RN4notifications', JSON.stringify([]))
            return {
                ...state,
                notifications: []
            }
        default:
            return state;
    }
};

export default Reducer;